import { Administration, Audit, Billing, Brand, Content, ContentMarketing, ECOMM, Finance, Game, Graphic, HR, Information, IT, Marketing, MarketingExternal, Motion, Procurement, Sales, SEO, SEOExternal, Software, Web, Web2 } from "./icons";

export default {
    "-": Graphic,
    "Team Alan Murphy": Brand,
    "Team Kevin Bacon": Software,
    "Pending": Sales,
    "Active": IT,
    "Voicemail": Administration,
    "Square Space Tech": Motion,
    "Square Space Xperts": SEO,
    "Wix Launch Pad": HR,
    "Web": Finance,
    "Social Media": Marketing,
    "Last 7 Days": Content,
    "Last 15 Days": ECOMM,
    "Last 30 Days": Billing,
    "Last 60 Days": Web,
    "Last 90 Days": Procurement,


    // "Management Information System": Information,
    // "Digital Marketing External": MarketingExternal,
    // "SEO External": SEOExternal,
    // "Audit & Compliance": Audit,
    // "Content Marketing": ContentMarketing,
    // "Web Production - Unit II": Web2,
    // "Game Development": Game
}